var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('SellStockProducts',{attrs:{"orders-articles":_vm.ordersArticles},on:{"sendArticle":_vm.setArticleNumber,"resetAllMateriales":_vm.resetAllMateriale}}),_c('SellFromStockLocation',{attrs:{"article-number":_vm.articleNumber},on:{"addToOrder":_vm.addOrder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }